import { render, staticRenderFns } from "./AdminDepositPayOffDialog.vue?vue&type=template&id=1c127fd4&scoped=true&"
import script from "./AdminDepositPayOffDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminDepositPayOffDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDepositPayOffDialog.vue?vue&type=style&index=0&id=1c127fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c127fd4",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QSeparator,QBtn,QTooltip,QIcon});
